export function element<K extends keyof HTMLElementTagNameMap>(tag: K, className: string, text?: string): HTMLElementTagNameMap[K] {
	const el = document.createElement(tag);
	el.className = className;
	if (text) el.textContent = text;
	return el;
}

export const button = (className: string, text: string, click: () => void) => {
	const el = element("button", className, text);
	el.type = "button";
	el.addEventListener("click", click);
	return el;
};
